var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "ul",
    {
      staticClass: "courseware-structural-element-selector",
      attrs: {
        role: "radiogroup",
      },
    },
    [
      _vm.rootElement !== null
        ? _c("courseware-structural-element-selector-item", {
            attrs: {
              element: _vm.rootElement,
              siblings: [],
              selectedId: _vm.selectedId,
              focusedElementId: _vm.focusedElementId,
              rootId: _vm.rootId,
              validateAncestors: _vm.validateAncestors,
              targetId: _vm.targetId,
              targetAncestors: _vm.targetAncestors,
              selectablePurposes: _vm.selectablePurposes,
            },
            on: {
              input: _vm.handleInput,
              focus: _vm.handleFocus,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }